import React from 'react'
import makeLoadable from 'rmw-shell/lib/containers/MyLoadable'
import RestrictedRoute from 'rmw-shell/lib/containers/RestrictedRoute'


const MyLoadable = (opts, preloadComponents) => makeLoadable({ ...opts, firebase: () => import('./firebase') }, preloadComponents)

const AsyncDashboard = MyLoadable({ loader: () => import('./containers/Dashboard/Dashboard') });
const AsyncDocument = MyLoadable({ loader: () => import('./containers/Document/Document') });
const AsyncCollection = MyLoadable({ loader: () => import('./containers/Collection/Collection') });
const AsyncAbout = MyLoadable({ loader: () => import('./containers/About/About') });
const AsyncTask = MyLoadable({ loader: () => import('./containers/Tasks/Task') });
const AsyncTasks = MyLoadable({ loader: () => import('./containers/Tasks/Tasks') }/*, [AsyncTask]*/);
const AsyncCompany = MyLoadable({ loader: () => import('./containers/Companies/Company') });
const AsyncCompanies = MyLoadable({ loader: () => import('./containers/Companies/Companies') }, [AsyncCompany]);
const AsyncVehicle = MyLoadable({ loader: () => import('./containers/Vehicles/Vehicle') });
const AsyncVehicles = MyLoadable({ loader: () => import('./containers/Vehicles/Vehicles') }, [AsyncVehicle]);
// const AsyncExpense = MyLoadable({ loader: () => import('./containers/Vehicles/Vehicle') });
const AsyncExpenses = MyLoadable({ loader: () => import('./containers/Expenses/Expenses') });
const AsyncService = MyLoadable({ loader: () => import('./containers/Services/Service') });
const AsyncServicePrint = MyLoadable({ loader: () => import('./containers/Services/ServicePrint') });
const AsyncServiceReceiptPrint = MyLoadable({ loader: () => import('./containers/Services/ServiceReceiptPrint') });
const AsyncServices = MyLoadable({ loader: () => import('./containers/Services/Services') }, [AsyncService]);
const AsyncReceipt = MyLoadable({ loader: () => import('./containers/Receipts/Receipt') });
const AsyncReceipts = MyLoadable({ loader: () => import('./containers/Receipts/Receipts') }, [AsyncReceipt]);
const AsyncSlipPrint = MyLoadable({ loader: () => import('./containers/Slips/SlipPrint') });
const AsyncSlip = MyLoadable({ loader: () => import('./containers/Slips/Slip') });
const AsyncSlips = MyLoadable({ loader: () => import('./containers/Slips/Slips') }, [AsyncSlip]);

const Routes = [
    <RestrictedRoute type='private' path="/" exact component={AsyncDashboard} />,
    <RestrictedRoute type='private' path="/dashboard" exact component={AsyncDashboard} />,
    <RestrictedRoute type='private' path="/vehicles" exact component={AsyncVehicles} />,
    <RestrictedRoute type='private' path="/vehicles/edit/:uid" exact component={AsyncVehicle} />,
    <RestrictedRoute type='private' path="/vehicles/create" exact component={AsyncVehicle} />,
    <RestrictedRoute type='private' path="/vehicles/:vuid/expenses/" exact component={AsyncExpenses} />,
    <RestrictedRoute type='private' path="/expenses" exact component={AsyncExpenses} />,
	<RestrictedRoute type='private' path="/services/:suid/expenses/" exact component={AsyncExpenses} />,
    <RestrictedRoute type='private' path="/tasks" exact component={AsyncTasks} />,
    <RestrictedRoute type='private' path="/tasks/edit/:uid" exact component={AsyncTask} />,
    <RestrictedRoute type='private' path="/tasks/create" exact component={AsyncTask} />,
    <RestrictedRoute type='private' path="/companies" exact component={AsyncCompanies} />,
    <RestrictedRoute type='private' path="/companies/edit/:uid" exact component={AsyncCompany} />,
    <RestrictedRoute type='private' path="/companies/create" exact component={AsyncCompany} />,
    <RestrictedRoute type='private' path="/services" exact component={AsyncServices} />,
    <RestrictedRoute type='private' path="/services/edit/:uid" exact component={AsyncService} />,
    <RestrictedRoute type='private' path="/quotations/:uid" exact component={AsyncServicePrint} />,
    <RestrictedRoute type='private' path="/services/receipt/:uid/:quid" exact component={AsyncServiceReceiptPrint} />,
    <RestrictedRoute type='private' path="/services/create" exact component={AsyncService} />,
    <RestrictedRoute type='private' path="/receipts" exact component={AsyncReceipts} />,
    <RestrictedRoute type='private' path="/services/:suid/receipts/" exact component={AsyncReceipts} />,
    <RestrictedRoute type='private' path="/services/:suid/receipts/create" exact component={AsyncReceipt} />,
    <RestrictedRoute type='private' path="/receipts/create" exact component={AsyncReceipt} />,
    <RestrictedRoute type='private' path="/receipts/edit/:uid" exact component={AsyncReceipt} />,
    <RestrictedRoute type='private' path="/receipts/print/:uid/:quid" exact component={AsyncServiceReceiptPrint} />,
    <RestrictedRoute type='private' path="/slips" exact component={AsyncSlips} />,
    <RestrictedRoute type='private' path="/services/:suid/slips/" exact component={AsyncSlips} />,
    <RestrictedRoute type='private' path="/services/:suid/slips/create" exact component={AsyncSlip} />,
    <RestrictedRoute type='private' path="/slips/create" exact component={AsyncSlip} />,
    <RestrictedRoute type='private' path="/slips/edit/:uid" exact component={AsyncSlip} />,
    <RestrictedRoute type='private' path="/slips/print/:uid/:quid" exact component={AsyncSlipPrint} />,
    <RestrictedRoute type='private' path="/expenses" exact component={AsyncExpenses} />,
    <RestrictedRoute type='private' path="/about" exact component={AsyncAbout} />,
]

export default Routes;


// WEBPACK FOOTER //
// ./src/routes.js